module.exports = __webpack_public_path__ + "static/screely-03b568caab13b1611f2ae25b142ca4cf.svg";